import { NgxsModuleOptions } from '@ngxs/store';
import { ApplicationConfig } from './application.config';
import { AuthState } from '../../shared/store/auth/auth.state';
import { ApplicationState } from '../../shared/store/application/application.state';
import { CacheDataState } from '../../shared/store/cache-data/cache-data.state';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin';
import { MessageState } from '../../page/message/store/message.state';
import { UserState } from '../../page/user/store/user.state';
import { MedicalCaseState } from '../../page/medical-case/store/medical-case.state';
import { MedicalCasePipelineStepState } from '../../page/medical-case/store/medical-case-pipeline-step.state';
import { MedicalCasePreparationFilesState } from '../../page/medical-case/store/medical-case-preparation-files.state';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !ApplicationConfig.production,
  selectorOptions: {
    suppressErrors: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
};

export const ngxsStorageConfig: NgxsStoragePluginOptions = {
  namespace: ApplicationConfig.applicationName,
  keys: [
    'auth.token',
    'auth.account',
    'auth.tokenSavedAt',
    'auth.username',
    'application.language',
  ],
};

export const ngxsStates = [
  AuthState,
  ApplicationState,
  CacheDataState,
  MessageState,
  UserState,
  MedicalCaseState,
  MedicalCasePipelineStepState,
  MedicalCasePreparationFilesState,
];
